import * as React from 'react'
import { connect } from 'react-redux'

import { SRPRS } from 'components/_Assets/svg/Icon/srprs'
import Box from 'components/Box'
import { Button } from 'components/Button'
import { Grid, GridGap } from 'components/Grid'
import Heading from 'components/Heading'
import Input from 'components/Input'
import { Modal, ModalContent, ModalHeader } from 'components/Modal'
import Textarea from 'components/Textarea'

import { getCdnUrl } from '../../../data/api/cdn'
import { EntryModalProps } from '../../../data/entries/types'
import { PerCountry, SiteCountry } from '../../../data/models/locale'
import { getClient } from '../../../data/openapi'
import { AppState } from '../../../data/state'
import DisplayContent from '../../shared/content'

interface OriginalModalState {
  name: string
  email: string
  idea: string
  success: boolean
  submitted: boolean
}

interface OriginalModalStateProps {
  country: SiteCountry
}

interface OriginalModalProps extends EntryModalProps, OriginalModalStateProps {}

class OriginalModal extends React.Component<
  OriginalModalProps,
  OriginalModalState
> {
  constructor(props: OriginalModalProps) {
    super(props)
    this.state = {
      name: '',
      email: '',
      idea: '',
      success: false,
      submitted: false,
    }
  }

  public render() {
    const placeholder: PerCountry<string> = {
      [SiteCountry.dk]: 'Din ide',
      [SiteCountry.nl]: 'Your idea',
      [SiteCountry.be]: 'Your idea',
      [SiteCountry.uk]: 'Your idea',
      [SiteCountry.ie]: 'Your idea',
    }

    const { country } = this.props

    return (
      <Modal
        size="xl"
        animationType="1"
        backdrop
        color={false}
        sticky
        onDismiss={this.props.onClose}
      >
        <ModalHeader />
        <div>
          <ModalContent>
            <Heading icon={SRPRS.sliders} iconTop>
              <DisplayContent contentKey="own-original-heading">
                Make your own flavour
              </DisplayContent>
            </Heading>
            <p>
              <DisplayContent contentKey="own-original-p">
                If you have a great idea for a new flavour, then let us know and
                you might a free trip.
              </DisplayContent>
            </p>
          </ModalContent>
          <ModalContent backgroundImage={getCdnUrl('card-original.jpg')}>
            <Box>
              {this.state.success ? (
                <Heading level={3}>
                  <DisplayContent contentKey="own-original-thanks">
                    Thanks for your idea
                  </DisplayContent>
                </Heading>
              ) : (
                <form
                  action="javascript:"
                  method="POST"
                  onSubmit={this.onSubmit}
                >
                  <Grid nrCols={[1, 2]} colGap={[GridGap.m]}>
                    <Input
                      name="first-name"
                      label={
                        <DisplayContent edit={true} contentKey="firstname">
                          First name
                        </DisplayContent>
                      }
                      type="text"
                      value={this.state.name}
                      handleChange={name => this.setState({ name })}
                      styleProps={{ hasFloatingLabel: true }}
                      componentProps={{ required: true }}
                    />
                    <Input
                      name="email"
                      label={
                        <DisplayContent edit={true} contentKey="email">
                          Email
                        </DisplayContent>
                      }
                      type="email"
                      value={this.state.email}
                      handleChange={email => this.setState({ email })}
                      styleProps={{ hasFloatingLabel: true }}
                      componentProps={{ required: true }}
                    />
                  </Grid>
                  <br />
                  <Textarea
                    inputName="idea"
                    value={this.state.idea}
                    onChange={idea => this.setState({ idea })}
                    placeholder={placeholder[country]}
                    required
                  />
                  <Button cutOff="left" disabled={this.state.submitted} submit>
                    <DisplayContent contentKey="own-original-submit">
                      Submit idea
                    </DisplayContent>
                  </Button>
                </form>
              )}
            </Box>
          </ModalContent>
        </div>
      </Modal>
    )
  }

  private onSubmit = () => {
    this.setState({ submitted: true }, () => {
      const data = {
        name: this.state.name,
        email: this.state.email,
        idea: this.state.idea,
      }
      getClient()
        .then(client => client.apis.bookings.bookings_original_idea({ data }))
        .then(() => {
          this.setState({
            success: true,
            submitted: false,
          })
        })
    })
  }
}

export default connect<OriginalModalStateProps, {}, {}, AppState>(state => ({
  country: state.locale.country,
}))(OriginalModal)
